const requestIdNamespace = 'quality.vet/self-signup/idempotency/v1';

function normalizeSignupIdentity(value: string): string {
  return value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
}

export async function signupClientRequestId(
  email: string,
  organisationName: string,
  termsVersion: string,
  termsHash: string,
): Promise<string> {
  const identity = JSON.stringify([
    requestIdNamespace,
    normalizeSignupIdentity(email),
    normalizeSignupIdentity(organisationName),
    termsVersion,
    termsHash,
  ]);
  const digest = new Uint8Array(
    await crypto.subtle.digest('SHA-256', new TextEncoder().encode(identity)),
  );
  const uuidBytes = digest.slice(0, 16);

  // Use the UUID v5/variant bit layout for a deterministic, schema-compatible identifier.
  uuidBytes[6] = (uuidBytes[6]! & 0x0f) | 0x50;
  uuidBytes[8] = (uuidBytes[8]! & 0x3f) | 0x80;
  const hex = [...uuidBytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
